// SlideToggle.js
import React, { useState, useEffect } from 'react';
import './SlideToggle.scss';
import { use } from 'react';

const SlideToggle = ({ label, initial = false, onToggle }) => {
  const [isToggled, setIsToggled] = useState(initial);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    const newState = !isToggled;
    setIsToggled(newState);
    if (onToggle){
        setIsLoading(true);
        await onToggle(newState);
        setIsLoading(false);
    } 
  };

  useEffect(() => {
    setIsToggled(initial);
  }, [initial]);
  return (
    <div className={`slide-toggle ${isToggled ? 'active' : ''}`} onClick={handleClick}>
      <div className="toggle-track">
        <div className="toggle-thumb"></div>
      </div>
      {label && <span class="m-l-8">{label}</span>}
      {isLoading && <span className="toggle-label">Loading...</span>}
    </div>
  );
};

export default SlideToggle;
